import useAuth from "features/auth/useAuth";
import React from "react";
import FailureViewDefault from "./default/FailureViewDefault";
import FailureViewRepairer from "./repairer/FailureViewRepairer";
import Claims from "features/auth/claims";

const FailureViewHub: React.FC = () => {
  const { hasClaim } = useAuth();
  const view = localStorage.getItem("fortana-view");

  return (hasClaim([Claims.View.Tablet]) && !hasClaim([Claims.View.Desktop])) ||
    (view === "tablet" &&
      hasClaim([Claims.View.Desktop]) &&
      hasClaim([Claims.View.Tablet])) ? (
    <FailureViewRepairer />
  ) : (
    <FailureViewDefault />
  );
};

export default FailureViewHub;
